/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    price: { type: 'variant', values: [ 'default', 'baseline' ] },
    size: {
      type: 'variant',
      values: [ 'micro', 'small', 'medium', 'large' ]
    },
    strikeThrough: { type: 'variant', values: [ true ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { size: 'micro' },
      tokens: {
        amountFontSize: 28,
        bottomTextFontSize: 14,
        bottomTextLineHeight: 1.42857142857,
        centsFontSize: 16,
        centsLineHeight: 1.33333333333,
        currencySymbolFontSize: 16,
        currencySymbolLineHeight: 1.25,
        rateFontSize: 14,
        rateLineHeight: 1.14285714286,
        strikeThroughPosition: 15,
        topTextFontSize: 14,
        topTextLineHeight: 1.42857142857
      }
    },
    {
      if: { size: 'small' },
      tokens: {
        amountFontSize: 28,
        bottomTextFontSize: 14,
        bottomTextLineHeight: 1.42857142857,
        centsFontSize: 16,
        centsLineHeight: 1.33333333333,
        currencySymbolFontSize: 16,
        currencySymbolLineHeight: 1.25,
        rateFontSize: 14,
        rateLineHeight: 1.14285714286,
        strikeThroughPosition: 15,
        topTextFontSize: 14,
        topTextLineHeight: 1.42857142857
      }
    },
    {
      if: { size: 'large' },
      tokens: {
        amountFontSize: 64,
        bottomTextFontSize: 16,
        bottomTextLineHeight: 1.5,
        centsFontSize: 36,
        centsLineHeight: 1.125,
        currencySymbolFontSize: 36,
        currencySymbolLineHeight: 1.125,
        rateFontSize: 20,
        rateLineHeight: 1.6,
        strikeThroughHeight: 3,
        strikeThroughPosition: 35,
        topTextFontSize: 16,
        topTextLineHeight: 1.5
      }
    },
    {
      if: { size: 'large', viewport: [ 'lg', 'xl' ] },
      tokens: {
        bottomTextFontSize: 20,
        bottomTextLineHeight: 1.6,
        topTextFontSize: 20,
        topTextLineHeight: 1.6
      }
    },
    {
      if: { strikeThrough: true },
      tokens: { fontColor: '#676e73', footnoteLinkColor: '#676e73' }
    },
    {
      if: { price: 'baseline' },
      tokens: {
        centsFontName: 'HNforTELUSSA',
        centsFontSize: 40,
        centsFontWeight: '300',
        centsLineHeight: 1
      }
    },
    {
      if: { price: 'baseline', size: 'micro' },
      tokens: {
        centsFontName: 'HNforTELUSSA',
        centsFontSize: 28,
        centsFontWeight: '300',
        centsLineHeight: 1
      }
    },
    {
      if: { price: 'baseline', size: 'small' },
      tokens: {
        centsFontName: 'HNforTELUSSA',
        centsFontSize: 28,
        centsFontWeight: '300',
        centsLineHeight: 1
      }
    },
    {
      if: { price: 'baseline', size: 'large' },
      tokens: {
        centsFontName: 'HNforTELUSSA',
        centsFontSize: 64,
        centsFontWeight: '300',
        centsLineHeight: 1
      }
    }
  ],
  tokens: {
    alignItemsText: 'flex-start',
    amountFontName: 'HNforTELUSSA',
    amountFontSize: 40,
    amountFontWeight: '300',
    amountLetterSpacing: -0.039,
    amountLineHeight: 1,
    bottomLinksMarginLeft: 4,
    bottomTextFontSize: 16,
    bottomTextLineHeight: 1.5,
    bottomTextMarginTop: 4,
    centsFontName: 'HNforTELUSSA',
    centsFontSize: 20,
    centsFontWeight: '400',
    centsLineHeight: 1.2,
    centsPaddingTop: 0,
    currencySymbolFontName: 'HNforTELUSSA',
    currencySymbolFontSize: 20,
    currencySymbolFontWeight: '400',
    currencySymbolLineHeight: 1.2,
    currencySymbolPaddingTop: 0,
    dividerColor: '#b2b9bf',
    fontColor: '#414547',
    fontName: 'HNforTELUSSA',
    fontWeight: '700',
    footnoteGap: 4,
    footnoteLinkColor: '#414547',
    footnoteLinkFontName: 'HNforTELUSSA',
    footnoteLinkFontSize: 14,
    footnoteLinkFontWeight: '400',
    footnoteLinkLineHeight: 1.42857142857,
    footnoteMarginTop: 4,
    priceMarginBottom: 8,
    rateFontName: 'HNforTELUSSA',
    rateFontSize: 16,
    rateFontWeight: '400',
    rateLineHeight: 1.25,
    strikeThroughColor: '#676e73',
    strikeThroughHeight: 2,
    strikeThroughPosition: 22,
    topTextFontName: 'HNforTELUSSA',
    topTextFontSize: 16,
    topTextFontWeight: '700',
    topTextLineHeight: 1.5,
    topTextMarginBottom: 4
  }
}
export default theme
